import DOMPurify from 'dompurify';
import type { Directive } from 'vue';

const ALLOWED_TAGS = [
  'b',
  'i',
  'em',
  'strong',
  'br',
  'img',
  'a',
  'p',
  'ul',
  'ol',
  'li',
  'span',
  'em',
  'mark',
  'blockquote',
  'pre',
  'dl',
  'dt',
  'dd',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'dfn',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'style'];

function sanitize(value: string): string {
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}

export const vSafeHtml: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    el.innerHTML = sanitize(binding.value ?? '');
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitize(binding.value ?? '');
    }
  },
};
